import { render, staticRenderFns } from "./explainText.vue?vue&type=template&id=08d0be59&scoped=true&"
import script from "./explainText.vue?vue&type=script&lang=ts&"
export * from "./explainText.vue?vue&type=script&lang=ts&"
import style0 from "./explainText.vue?vue&type=style&index=0&id=08d0be59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d0be59",
  null
  
)

export default component.exports